"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PasswordForgottenCard;
require("core-js/modules/es.promise.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _formik = require("formik");
var _auth = require("firebase/auth");
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _analytics = require("firebase/analytics");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function PasswordForgottenCard(props) {
  const {
    setemailPasswordCardType,
    t,
    globalActions,
    auth,
    analytics
  } = props;
  async function passwordResetEmail(email, setSubmitting) {
    try {
      await (0, _auth.sendPasswordResetEmail)(auth, email, {
        url: "".concat(window.location.protocol, "//").concat(window.location.host, "/signin?reset_success=true")
      });
      globalActions.setSnackbarMessage({
        message: t('signin.forgotten_password_mail_sent'),
        severity: 'info'
      });
      setemailPasswordCardType('signin');
    } catch (error) {
      setSubmitting(false);
      globalActions.setSnackbarMessage({
        message: error.message,
        severity: 'error'
      });
      (0, _analytics.logEvent)(analytics, 'reset_password_error', {
        error_message: error.message
      });
    }
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      p: 3,
      gap: 1,
      width: {
        xs: '100%',
        sm: '88%'
      },
      maxWidth: 670
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "span",
    variant: "subtitle1",
    gutterBottom: true
  }, t('signin.password_forgotten')), /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: {
      email: ''
    },
    validate: values => {
      const errors = {};
      if (!values.email) {
        errors.email = t('validations.required');
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = t('validations.email_invalid');
      }
      return errors;
    },
    onSubmit: async (values, _ref) => {
      let {
        setSubmitting
      } = _ref;
      await passwordResetEmail(values.email, setSubmitting);
    }
  }, _ref2 => {
    let {
      values,
      errors,
      touched,
      handleChange,
      handleBlur,
      handleSubmit,
      isSubmitting
      /* and other goodies */
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("form", {
      style: {
        width: '100%'
      },
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react.default.createElement(_Box.default, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      component: "span"
    }, t('signin.password_forgotten_info')), /*#__PURE__*/_react.default.createElement(_material.TextField, {
      style: {
        maxWidth: 300
      },
      fullWidth: true,
      type: "email",
      name: "email",
      onChange: handleChange,
      onBlur: handleBlur,
      value: values.email,
      label: t('signin.email'),
      error: touched.email && Boolean(errors.email),
      helperText: errors.email && touched.email && errors.email
    }), /*#__PURE__*/_react.default.createElement(_material.Button, {
      variant: "contained",
      color: "primary",
      type: "submit",
      disabled: isSubmitting
    }, t('signin.reset_password')), /*#__PURE__*/_react.default.createElement(_material.Link, {
      sx: {
        cursor: 'pointer'
      },
      onClick: () => setemailPasswordCardType('signin'),
      color: "secondary"
    }, t('signin.return_login'))));
  }));
}